<script>
export default {
  name: 'CtaBookBriefing',

  props: {
    label: String,
    css: String,

    countriesList: {
      type: Array,
      required: true,
    },
  },

  methods: {
    openBookBriefingModal() {
      this.$root.openBookBriefingModal({
        ...this.$props,
        hasCloseButton: true,
      })
    },
  },
}
</script>

<template>
  <button
    :class="css"
    class="btn mb-8 text-xs font-semibold"
    @click="openBookBriefingModal">
    {{ label }}
  </button>
</template>
